/**
 * /eric/active — Active tasks across all subscribers (T-050, PR-28, PR-38).
 *
 * Route config only. Component lives in eric.active.lazy.tsx (code-split).
 * No loader, beforeLoad, or validateSearch.
 */

import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/eric/active')({});
